var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZipcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.89313 6.96812L14 2.125L26.1069 6.96812C26.2229 7.01446 26.3223 7.09448 26.3924 7.19785C26.4624 7.30123 26.4999 7.42324 26.5 7.54813V25.25C26.5 25.4158 26.4342 25.5747 26.3169 25.6919C26.1997 25.8092 26.0408 25.875 25.875 25.875H2.125C1.95924 25.875 1.80027 25.8092 1.68306 25.6919C1.56585 25.5747 1.5 25.4158 1.5 25.25V7.54813C1.50008 7.42324 1.53757 7.30123 1.60764 7.19785C1.67771 7.09448 1.77715 7.01446 1.89313 6.96812Z",
    stroke: "#BDBDBD",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12.75V19",
    stroke: "#BDBDBD",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.625 15.875C20.6606 15.875 21.5 15.175 21.5 14.3125C21.5 13.45 20.6606 12.75 19.625 12.75H17.9375C17.8878 12.75 17.8401 12.7698 17.8049 12.8049C17.7698 12.8401 17.75 12.8878 17.75 12.9375V14.3125C17.75 15.175 18.5894 15.875 19.625 15.875Z",
    stroke: "#BDBDBD",
    strokeWidth: 2.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 12.75V19",
    stroke: "#BDBDBD",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.75H10.2531L6.5 19H10.2531",
    stroke: "#BDBDBD",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZipcode);
export default __webpack_public_path__ + "static/media/zipcode.b3ceca2eda173d695f8ddd2a5b0dd71c.svg";
export { ForwardRef as ReactComponent };